import OurClients from "components/OurClients";
import OurServices from "components/OurServices";
import PageHeader from "components/PageHeader";
import StoreReviews from "features/storeReviews";
import WhoAreWe from "components/WhoAreWe/WhoAreWe";
import { setBreadcrumbTitle } from "features/breadcrumb/breadcrumbSlice";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useDispatch } from "react-redux";
import styled from "styled-components/macro";
import { device } from "theme/Breakpoints";

interface AboutProps {}

const About: React.FC<AboutProps> = ({}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setBreadcrumbTitle("За нас"));

    return () => {
      dispatch(setBreadcrumbTitle(""));
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>За нас</title>
      </Helmet>
      <AboutContainer>
        <PageHeader title={"За нас"} subtitle={"Разберете повече за нас"} />
        {/* about us stoty */}
        <WhoAreWe />
        {/* our services */}
        <OurServices />
        {/* our clients */}
        <OurClients />
        {/* client store reviews */}
        <StoreReviews />
      </AboutContainer>
    </>
  );
};

const AboutContainer = styled.div``;

export default About;
